export const PROJECT_TITLE = 'Sett Solutions Admin'

export const ICAL_MSG = 'Please note that you need to add a payment method to enable ICal link integration.'

export const SIDEBAR_MENU = [
  { path: '/overview', title: 'Overview', icon: 'clipboard' },
  { path: '/calendar', title: 'Calendar', icon: 'calendar' },
  { path: '/admin-control', title: 'Admin Control', icon: 'settings', permission: 'adminControl' },
  { path: '/cleaners', title: 'Cleaners', icon: 'feather' },
  { path: '/clients', title: 'Clients', icon: 'users' },
  { path: '/coupons', title: 'Coupons', icon: 'percent', permission: 'coupons' },
  { path: '/emails', title: 'Emails', icon: 'mail', permission: 'emails' },
  { path: '/push-notification', title: 'Push Notification', icon: 'bell', permission: 'pushNotifications' },
  { path: '/payments', title: 'Payments', icon: 'credit-card', permission: 'payments' },
  { path: '/pricing', title: 'Pricing Table', icon: 'dollar-sign', permission: 'pricingTable' },
  { path: '/regions', title: 'Regions', icon: 'map-pin', permission: 'regions' },
  { path: '/cleaner-report-category', title: 'Cleaner Report Category', icon: 'alert-octagon', permission:'cleanerReportCategory' },
  { path: '/reports', title: 'Reports', icon: 'file-text', permission: 'reports' },
  { path: '/host-tasks', title: 'Host Tasks', icon: 'check-square', permission: 'hostTasks' }
]

export const CALENDAR_EVENT = [
  {
    title: 'LOFT 317',
    date: '2024-07-01',
    host_name: 'John Deo',
    cleaner_name: 'Alexandra Bond',
    accepted: false,
    checkout: '2024-07-01T10:30:00',
    next_check_in: '2024-07-01T11:30:00',
    status: 'done',
    color: '#73D671'
  },
  {
    title: 'FONT 2BED',
    date: '2024-07-01',
    host_name: 'Charles Cornish',
    cleaner_name: 'Boris Hardacre',
    accepted: false,
    checkout: '2024-07-01T08:30:00',
    next_check_in: '2024-07-01T09:30:00',
    status: 'done',
    color: '#73D671'
  },
  {
    title: '87 CASTELLINA',
    date: '2024-07-02',
    host_name: 'Sophie McDonald',
    cleaner_name: 'Michael Lee',
    accepted: true,
    checkout: '2024-07-02T10:30:00',
    next_check_in: '2024-07-02T11:30:00',
    status: 'Schedule',
    color: '#589FBC'
  }
]

export const ADMIN_CONTROL = [
  {
    id: 1,
    first_name: 'John',
    last_name: 'Doe',
    email: 'example@gmail.com',
    admin_type: 'manager admin',
    region: 'Ahmedabad, Gujarat, India',
    status: 'Active',
    profile: 'profile_url_1' // Replace with actual profile URL
  },
  {
    id: 2,
    first_name: 'Jane',
    last_name: 'Doe',
    email: 'example@gmail.com',
    admin_type: 'admin',
    region: 'Mumbai, Maharashtra, India',
    status: 'Active',
    profile: 'profile_url_2' // Replace with actual profile URL
  },
  {
    id: 3,
    first_name: 'Mike',
    last_name: 'Wilson',
    email: 'example@gmail.com',
    admin_type: 'manager admin',
    region: 'Delhi, Delhi NCR, India',
    status: 'Inactive',
    profile: 'profile_url_3' // Replace with actual profile URL
  },
  {
    id: 4,
    first_name: 'Alice',
    last_name: 'Johnson',
    email: 'example@gmail.com',
    admin_type: 'super admin',
    region: 'Bangalore, Karnataka, India',
    status: 'Active',
    profile: 'profile_url_4' // Replace with actual profile URL
  },
  {
    id: 5,
    first_name: 'David',
    last_name: 'Miller',
    email: 'example@gmail.com',
    admin_type: 'manager admin',
    region: 'Chennai, Tamil Nadu, India',
    status: 'Active',
    profile: 'profile_url_5' // Replace with actual profile URL
  },
  {
    id: 6,
    first_name: 'Sarah',
    last_name: 'Williams',
    email: 'example@gmail.com',
    admin_type: 'manager admin',
    region: 'Hyderabad, Telangana, India',
    status: 'Inactive',
    profile: 'profile_url_6' // Replace with actual profile URL
  },
  {
    id: 7,
    first_name: 'William',
    last_name: 'Brown',
    email: 'example@gmail.com',
    admin_type: 'manager admin',
    region: 'Kolkata, West Bengal, India',
    status: 'Active',
    profile: 'profile_url_7' // Replace with actual profile URL
  },
  {
    id: 8,
    first_name: 'Jennifer',
    last_name: 'Jones',
    email: 'example@gmail.com',
    admin_type: 'manager admin',
    region: 'Pune, Maharashtra, India',
    status: 'Active',
    profile: 'profile_url_8' // Replace with actual profile URL
  },
  {
    id: 9,
    first_name: 'Matthew',
    last_name: 'Davis',
    email: 'example@gmail.com',
    admin_type: 'manager admin',
    region: 'Jaipur, Rajasthan, India',
    status: 'Inactive',
    profile: 'profile_url_9' // Replace with actual profile URL
  },
  {
    id: 10,
    first_name: 'Elizabeth',
    last_name: 'Garcia',
    email: 'example@gmail.com',
    admin_type: 'manager admin',
    region: 'Surat, Gujarat, India',
    status: 'Active',
    profile: 'profile_url_10' // Replace with actual profile URL
  },
  {
    id: 11,
    first_name: 'Kevin',
    last_name: 'Johnson',
    email: 'example@gmail.com',
    admin_type: 'manager admin',
    status: 'Active',
    region: 'Bharuch, Gujarat, India',
    profile: 'user_avatar.gif'
  },
  {
    id: 12,
    first_name: 'Elizabeth',
    last_name: 'Lewis',
    email: 'example@gmail.com',
    admin_type: 'manager admin',
    status: 'Active',
    region: 'Tapi, Gujarat, India',
    profile: 'default_icon.jpg'
  }
]

export const CLIENTS = [
  {
    id: 1,
    profile: 'Host',
    first_name: 'John',
    last_name: 'Doe',
    email: 'john.doe@example.com',
    phone: '+1234567890',
    total_properties: 3,
    total_cleanings: 50,
    total_strikes: 1,
    rating_score: 4.8
  },
  {
    id: 2,
    profile: 'Guest',
    first_name: 'Jane',
    last_name: 'Smith',
    email: 'jane.smith@example.com',
    phone: '+0987654321',
    total_properties: 0,
    total_cleanings: 0,
    total_strikes: 0,
    rating_score: 4.9
  },
  {
    id: 3,
    profile: 'Host',
    first_name: 'Emily',
    last_name: 'Brown',
    email: 'emily.brown@example.com',
    phone: '+1122334455',
    total_properties: 5,
    total_cleanings: 75,
    total_strikes: 2,
    rating_score: 4.7
  },
  {
    id: 4,
    profile: 'Guest',
    first_name: 'Michael',
    last_name: 'Johnson',
    email: 'michael.johnson@example.com',
    phone: '+2233445566',
    total_properties: 0,
    total_cleanings: 0,
    total_strikes: 0,
    rating_score: 4.6
  },
  {
    id: 5,
    profile: 'Host',
    first_name: 'Sarah',
    last_name: 'Davis',
    email: 'sarah.davis@example.com',
    phone: '+3344556677',
    total_properties: 2,
    total_cleanings: 30,
    total_strikes: 1,
    rating_score: 4.9
  },
  {
    id: 6,
    profile: 'Guest',
    first_name: 'David',
    last_name: 'Miller',
    email: 'david.miller@example.com',
    phone: '+4455667788',
    total_properties: 0,
    total_cleanings: 0,
    total_strikes: 0,
    rating_score: 4.8
  },
  {
    id: 7,
    profile: 'Host',
    first_name: 'Laura',
    last_name: 'Wilson',
    email: 'laura.wilson@example.com',
    phone: '+5566778899',
    total_properties: 4,
    total_cleanings: 60,
    total_strikes: 1,
    rating_score: 4.6
  },
  {
    id: 8,
    profile: 'Guest',
    first_name: 'Robert',
    last_name: 'Moore',
    email: 'robert.moore@example.com',
    phone: '+6677889900',
    total_properties: 0,
    total_cleanings: 0,
    total_strikes: 0,
    rating_score: 4.5
  },
  {
    id: 9,
    profile: 'Host',
    first_name: 'Jessica',
    last_name: 'Taylor',
    email: 'jessica.taylor@example.com',
    phone: '+7788990011',
    total_properties: 6,
    total_cleanings: 90,
    total_strikes: 3,
    rating_score: 4.4
  },
  {
    id: 10,
    profile: 'Guest',
    first_name: 'Thomas',
    last_name: 'Anderson',
    email: 'thomas.anderson@example.com',
    phone: '+8899001122',
    total_properties: 0,
    total_cleanings: 0,
    total_strikes: 0,
    rating_score: 4.7
  },
  {
    id: 11,
    profile: 'Host',
    first_name: 'Ashley',
    last_name: 'Martinez',
    email: 'ashley.martinez@example.com',
    phone: '+9900112233',
    total_properties: 3,
    total_cleanings: 45,
    total_strikes: 2,
    rating_score: 4.5
  },
  {
    id: 12,
    profile: 'Guest',
    first_name: 'Brian',
    last_name: 'Garcia',
    email: 'brian.garcia@example.com',
    phone: '+1011121314',
    total_properties: 0,
    total_cleanings: 0,
    total_strikes: 0,
    rating_score: 4.8
  },
  {
    id: 13,
    profile: 'Host',
    first_name: 'Samantha',
    last_name: 'Rodriguez',
    email: 'samantha.rodriguez@example.com',
    phone: '+2021222324',
    total_properties: 1,
    total_cleanings: 20,
    total_strikes: 0,
    rating_score: 4.9
  },
  {
    id: 14,
    profile: 'Guest',
    first_name: 'Kevin',
    last_name: 'Hernandez',
    email: 'kevin.hernandez@example.com',
    phone: '+3031323334',
    total_properties: 0,
    total_cleanings: 0,
    total_strikes: 0,
    rating_score: 4.7
  },
  {
    id: 15,
    profile: 'Host',
    first_name: 'Amy',
    last_name: 'Martinez',
    email: 'amy.martinez@example.com',
    phone: '+4041424344',
    total_properties: 2,
    total_cleanings: 35,
    total_strikes: 1,
    rating_score: 4.8
  },
  {
    id: 16,
    profile: 'Guest',
    first_name: 'James',
    last_name: 'Lopez',
    email: 'james.lopez@example.com',
    phone: '+5051525354',
    total_properties: 0,
    total_cleanings: 0,
    total_strikes: 0,
    rating_score: 4.6
  }
]

export const PROPERTIES = [
  {
    properties_id: 'a1b2c3d4-e5f6-7g8h-9i0j-k1l2m3n4o5p6',
    client_id: 'f7e8d9c0-b1a2-3c4d-5e6f-7g8h9i0j1k2l',
    number_of_rooms: 3,
    number_of_bathroom: 2,
    sequre_foot: '1500 sqft',
    other: 'Pool, Garage',
    property_name: 'Cozy Cottage',
    zipcode: '12345',
    address: '123 Maple St',
    state: 'NY',
    city: 'Albany',
    location_latt: '42.6526',
    location_long: '-73.7562',
    get_in: 'Keybox',
    get_in_instruction: 'Keybox is located at the front door.',
    ical_links: {
      ical_link: 'http://example.com/ical/cozycottage.ics',
      ical_label: 'Cozy Cottage Calendar'
    },
    property_image: 'http://example.com/images/cozycottage.jpg',
    airbnb_listing_id: '12345678',
    airbnb_bedrooms: 3,
    airbnb_bathrooms: 2,
    main_cleaner: 'Rachel	Parsons',
    total_value: 135.0,
    cleaner_service_value: 90.0,
    is_active: true,
    is_deleted: false,
    created_by: 'a1b2c3d4-e5f6-7g8h-9i0j-k1l2m3n4o5p6',
    updated_by: 'a1b2c3d4-e5f6-7g8h-9i0j-k1l2m3n4o5p6',
    deleted_by: null,
    created_at: '1622548800',
    updated_at: '1622635200',
    deleted_at: null
  },
  {
    properties_id: 'b2c3d4e5-f6g7-h8i9-0j1k-l2m3n4o5p6q7',
    client_id: 'g8h9i0j1-k2l3-m4n5-o6p7-q8r9s0t1u2v3',
    number_of_rooms: 4,
    number_of_bathroom: 3,
    sequre_foot: '2000 sqft',
    other: 'Garden, Fireplace',
    property_name: 'Modern Villa',
    zipcode: '67890',
    address: '456 Oak St',
    state: 'CA',
    city: 'Los Angeles',
    location_latt: '34.0522',
    location_long: '-118.2437',
    get_in: 'Smart Lock',
    get_in_instruction: 'Enter the code on the smart lock.',
    ical_links: {
      ical_link: 'http://example.com/ical/modernvilla.ics',
      ical_label: 'Modern Villa Calendar'
    },
    property_image: 'http://example.com/images/modernvilla.jpg',
    airbnb_listing_id: '87654321',
    airbnb_bedrooms: 4,
    airbnb_bathrooms: 3,
    main_cleaner: 'Dorothy Coleman',
    total_value: 87.0,
    cleaner_service_value: 121.0,
    is_active: true,
    is_deleted: false,
    created_by: 'b2c3d4e5-f6g7-h8i9-0j1k-l2m3n4o5p6q7',
    updated_by: 'b2c3d4e5-f6g7-h8i9-0j1k-l2m3n4o5p6q7',
    deleted_by: null,
    created_at: '1622635200',
    updated_at: '1622721600',
    deleted_at: null
  },
  {
    properties_id: 'c3d4e5f6-g7h8-i9j0-k1l2-m3n4o5p6q7r8',
    client_id: 'h9i0j1k2-l3m4-n5o6-p7q8-r9s0t1u2v3w4',
    number_of_rooms: 2,
    number_of_bathroom: 1,
    sequre_foot: '1000 sqft',
    other: 'Balcony, Central Heating',
    property_name: 'City Apartment',
    zipcode: '54321',
    address: '789 Pine St',
    state: 'IL',
    city: 'Chicago',
    location_latt: '41.8781',
    location_long: '-87.6298',
    get_in: 'Doorman',
    get_in_instruction: 'Check in with the doorman.',
    ical_links: {
      ical_link: 'http://example.com/ical/cityapartment.ics',
      ical_label: 'City Apartment Calendar'
    },
    property_image: 'http://example.com/images/cityapartment.jpg',
    airbnb_listing_id: '23456789',
    airbnb_bedrooms: 2,
    airbnb_bathrooms: 1,
    main_cleaner: 'Gavin Knox',
    total_value: 43.0,
    cleaner_service_value: 78.0,
    is_active: true,
    is_deleted: false,
    created_by: 'c3d4e5f6-g7h8-i9j0-k1l2-m3n4o5p6q7r8',
    updated_by: 'c3d4e5f6-g7h8-i9j0-k1l2-m3n4o5p6q7r8',
    deleted_by: null,
    created_at: '1622721600',
    updated_at: '1622808000',
    deleted_at: null
  },
  {
    properties_id: 'd4e5f6g7-h8i9-j0k1-l2m3-n4o5p6q7r8s9',
    client_id: 'i0j1k2l3-m4n5-o6p7-q8r9-s0t1u2v3w4x5',
    number_of_rooms: 5,
    number_of_bathroom: 4,
    sequre_foot: '2500 sqft',
    other: 'Gym, Sauna',
    property_name: 'Luxury Penthouse',
    zipcode: '98765',
    address: '101 Elm St',
    state: 'TX',
    city: 'Dallas',
    location_latt: '32.7767',
    location_long: '-96.7970',
    get_in: 'Keycode',
    get_in_instruction: 'Enter the keycode on the keypad.',
    ical_links: {
      ical_link: 'http://example.com/ical/luxurypenthouse.ics',
      ical_label: 'Luxury Penthouse Calendar'
    },
    property_image: 'http://example.com/images/luxurypenthouse.jpg',
    airbnb_listing_id: '34567890',
    airbnb_bedrooms: 5,
    airbnb_bathrooms: 4,
    main_cleaner: 'Boris Cornish',
    total_value: 77.0,
    cleaner_service_value: 119.0,
    is_active: true,
    is_deleted: false,
    created_by: 'd4e5f6g7-h8i9-j0k1-l2m3-n4o5p6q7r8s9',
    updated_by: 'd4e5f6g7-h8i9-j0k1-l2m3-n4o5p6q7r8s9',
    deleted_by: null,
    created_at: '1622808000',
    updated_at: '1622894400',
    deleted_at: null
  },
  {
    properties_id: 'e5f6g7h8-i9j0-k1l2-m3n4-o5p6q7r8s9t0',
    client_id: 'j1k2l3m4-n5o6-p7q8-r9s0-t1u2v3w4x5y6',
    number_of_rooms: 3,
    number_of_bathroom: 2,
    sequre_foot: '1700 sqft',
    other: 'Home Theater, BBQ Area',
    property_name: 'Family Home',
    zipcode: '23456',
    address: '202 Birch St',
    state: 'FL',
    city: 'Miami',
    location_latt: '25.7617',
    location_long: '-80.1918',
    get_in: 'Lockbox',
    get_in_instruction: 'Lockbox is near the garage.',
    ical_links: {
      ical_link: 'http://example.com/ical/familyhome.ics',
      ical_label: 'Family Home Calendar'
    },
    property_image: 'http://example.com/images/familyhome.jpg',
    airbnb_listing_id: '45678901',
    airbnb_bedrooms: 3,
    airbnb_bathrooms: 2,
    main_cleaner: 'Alan King',
    total_value: 14.0,
    cleaner_service_value: 55.0,
    is_active: true,
    is_deleted: false,
    created_by: 'd4e5f6g7-h8i9-j0k1-l2m3-n4o5p6q7r8s9',
    updated_by: 'd4e5f6g7-h8i9-j0k1-l2m3-n4o5p6q7r8s9',
    deleted_by: null,
    created_at: '1622808000',
    updated_at: '1622894400',
    deleted_at: null
  }
]

export const acceptExtensions = {
  'image/*': ['.png', '.jpg', '.jpeg', '.gif']
}

export const acceptFileExtensions = ['image/jpeg', 'image/png', 'image/jpeg', 'image/gif']

export const defultPropertyValues = {
  property_name: '',
  client_id: '',
  number_of_rooms: null,
  number_of_bathroom: null,
  square_foot: null,
  other: '',
  zipcode: '',
  address: '',
  state: '',
  city: '',
  location_lat: '61.2181',
  location_long: '-149.9003',
  get_in: '',
  get_in_instruction: '',
  laundry_code: '',
  storage_area_code: '',
  timezone: 'America/Anchorage',
  // propertyICalLink: [
  //   {
  //     ical_label: '',
  //     ical_link: ''
  //   }
  // ],
  property_image: [],
  airbnb_listing_id: '1',
  airbnb_bedrooms: 3,
  airbnb_bathrooms: 3,
  request_laundry: false,
  cleaning_on: 'Cleaning on checkout',
  propertyTasks: [
    { property_cleaning_task_id: null, task: '' }
    // { property_cleaning_task_id: null, task: 'Refill coffee and soda/water' },
    // { property_cleaning_task_id: null, task: 'Change throw blanket' },
    // { property_cleaning_task_id: null, task: 'Check toilet refills' },
    // { property_cleaning_task_id: null, task: 'Mop the floor every time' }
  ],
  propertyConsumables: [
    { property_cleaning_consumable_id: null, task: '' }
    // { property_cleaning_consumable_id: null, task: 'Mop the floor every time' }
  ]
}

export const PAYMENT_DATA = [
  {
    id: '13154',
    host_name: 'James Smith',
    host_profile: '',
    region: 'Bay Area',
    cleaner_name: 'Reginaldo Jose',
    cleaner_profile: '',
    date: 'Feb.07,2025',
    cleaning: 'Vrbo_apartment',
    payment_status: 'pending',
    payment: '125.00'
  },
  {
    id: '13155',
    host_name: 'John Doe',
    host_profile: '',
    region: 'Los Angeles',
    cleaner_name: 'Maria Johnson',
    cleaner_profile: '',
    date: 'Feb.08,2025',
    cleaning: 'Airbnb_apartment',
    payment_status: 'Waiting_charge',
    payment: '170.00'
  },
  {
    id: '13156',
    host_name: 'Emily Clark',
    host_profile: '',
    region: 'Chicago',
    cleaner_name: 'David Lee',
    cleaner_profile: '',
    date: 'Feb.09,2025',
    cleaning: 'Vrbo_apartment',
    payment_status: 'pending',
    payment: '150.00'
  },
  {
    id: '13157',
    host_name: 'Michael Brown',
    host_profile: '',
    region: 'Miami',
    cleaner_name: 'Anna Bell',
    cleaner_profile: '',
    date: 'Feb.10,2025',
    cleaning: 'Vrbo_apartment',
    payment_status: 'Waiting_charge',
    payment: '200.00'
  },
  {
    id: '13158',
    host_name: 'Sophia Johnson',
    host_profile: '',
    region: 'New York',
    cleaner_name: 'Chris Evans',
    cleaner_profile: '',
    date: 'Feb.11,2025',
    cleaning: 'Airbnb_apartment',
    payment_status: 'paid',
    payment: '220.00'
  },
  {
    id: '13159',
    host_name: 'Lucas Walker',
    host_profile: '',
    region: 'Dallas',
    cleaner_name: 'Kim Watson',
    cleaner_profile: '',
    date: 'Feb.12,2025',
    cleaning: 'Vrbo_apartment',
    payment_status: 'Waiting_charge',
    payment: '175.00'
  },
  {
    id: '13160',
    host_name: 'David White',
    host_profile: '',
    region: 'San Francisco',
    cleaner_name: 'Jessica Miller',
    cleaner_profile: '',
    date: 'Feb.13,2025',
    cleaning: 'Airbnb_apartment',
    payment_status: 'Waiting_charge',
    payment: '145.00'
  },
  {
    id: '13161',
    host_name: 'Oliver Smith',
    host_profile: '',
    region: 'Austin',
    cleaner_name: 'Jack Wilson',
    cleaner_profile: '',
    date: 'Feb.14,2025',
    cleaning: 'Vrbo_apartment',
    payment_status: 'Waiting_charge',
    payment: '195.00'
  },
  {
    id: '13162',
    host_name: 'Emma Harris',
    host_profile: '',
    region: 'Seattle',
    cleaner_name: 'Sarah Green',
    cleaner_profile: '',
    date: 'Feb.15,2025',
    cleaning: 'Airbnb_apartment',
    payment_status: 'Waiting_charge',
    payment: '180.00'
  },
  {
    id: '13163',
    host_name: 'William Jones',
    host_profile: '',
    region: 'Phoenix',
    cleaner_name: 'Brian Taylor',
    cleaner_profile: '',
    date: 'Feb.16,2025',
    cleaning: 'Vrbo_apartment',
    payment_status: 'Waiting_charge',
    payment: '205.00'
  },
  {
    id: '13164',
    host_name: 'Amelia Moore',
    host_profile: '',
    region: 'Denver',
    cleaner_name: 'Nancy Adams',
    cleaner_profile: '',
    date: 'Feb.17,2025',
    cleaning: 'Airbnb_apartment',
    payment_status: 'Waiting_charge',
    payment: '160.00'
  },
  {
    id: '13165',
    host_name: 'Henry Scott',
    host_profile: '',
    region: 'Las Vegas',
    cleaner_name: 'Tom Baker',
    cleaner_profile: '',
    date: 'Feb.18,2025',
    cleaning: 'Vrbo_apartment',
    payment_status: 'Waiting_charge',
    payment: '210.00'
  }
]

export const ISSUERS_DATA = [
  {
    key: '1',
    cleaner: 'Reginaldo Jose',
    region: 'Bay Area',
    total_revenue: '$810.00',
    jobs_performed: 74,
    properties_serviced: 'Pending',
    cleaner_profile: 'path_to_image1'
  },
  {
    key: '2',
    cleaner: 'Reginaldo Jose',
    region: 'Bay Area',
    total_revenue: '$810.00',
    jobs_performed: 74,
    properties_serviced: 'Pending',
    cleaner_profile: 'path_to_image2'
  },
  {
    key: '3',
    cleaner: 'Reginaldo Jose',
    region: 'Bay Area',
    total_revenue: '$810.00',
    jobs_performed: 74,
    properties_serviced: 'Pending',
    cleaner_profile: 'path_to_image3'
  },
  {
    key: '4',
    cleaner: 'Reginaldo Jose',
    region: 'Bay Area',
    total_revenue: '$810.00',
    jobs_performed: 74,
    properties_serviced: 'Pending',
    cleaner_profile: 'path_to_image4'
  },
  {
    key: '5',
    cleaner: 'Reginaldo Jose',
    region: 'Bay Area',
    total_revenue: '$810.00',
    jobs_performed: 74,
    properties_serviced: 'Pending',
    cleaner_profile: 'path_to_image5'
  },
  {
    key: '6',
    cleaner: 'Reginaldo Jose',
    region: 'Bay Area',
    total_revenue: '$810.00',
    jobs_performed: 74,
    properties_serviced: 'Pending',
    cleaner_profile: 'path_to_image6'
  },
  {
    key: '7',
    cleaner: 'Reginaldo Jose',
    region: 'Bay Area',
    total_revenue: '$810.00',
    jobs_performed: 74,
    properties_serviced: 'Pending',
    cleaner_profile: 'path_to_image7'
  },
  {
    key: '8',
    cleaner: 'Reginaldo Jose',
    region: 'Bay Area',
    total_revenue: '$810.00',
    jobs_performed: 74,
    properties_serviced: 'Pending',
    cleaner_profile: 'path_to_image8'
  },
  {
    key: '9',
    cleaner: 'Reginaldo Jose',
    region: 'Bay Area',
    total_revenue: '$810.00',
    jobs_performed: 74,
    properties_serviced: 'Pending',
    cleaner_profile: 'path_to_image9'
  },
  {
    key: '10',
    cleaner: 'Reginaldo Jose',
    region: 'Bay Area',
    total_revenue: '$810.00',
    jobs_performed: 74,
    properties_serviced: 'Pending',
    cleaner_profile: 'path_to_image10'
  },
  {
    key: '11',
    cleaner: 'Reginaldo Jose',
    region: 'Bay Area',
    total_revenue: '$810.00',
    jobs_performed: 74,
    properties_serviced: 'Pending',
    cleaner_profile: 'path_to_image11'
  },
  {
    key: '12',
    cleaner: 'Reginaldo Jose',
    region: 'Bay Area',
    total_revenue: '$810.00',
    jobs_performed: 74,
    properties_serviced: 'Pending',
    cleaner_profile: 'path_to_image12'
  }
]

export const REPORTS_FIRST = [
  {
    key: '1',
    region: 'Los Angeles',
    totalRevenue: '$810.00',
    jobs: 74,
    totalClient: 6,
    totalProperties: 15,
    totalCleaners: 127
  },
  {
    key: '2',
    region: 'Atlanta',
    totalRevenue: '$815.00',
    jobs: 78,
    totalClient: 1,
    totalProperties: 7,
    totalCleaners: 2
  },
  {
    key: '3',
    region: 'Seattle',
    totalRevenue: '$0.00',
    jobs: 0,
    totalClient: 0,
    totalProperties: 0,
    totalCleaners: 6
  },
  {
    key: '4',
    region: 'Miami',
    totalRevenue: '$630.00',
    jobs: 248,
    totalClient: 3,
    totalProperties: 16,
    totalCleaners: 5
  },
  {
    key: '5',
    region: 'North Carolina',
    totalRevenue: '$416.00',
    jobs: 36,
    totalClient: 1,
    totalProperties: 3,
    totalCleaners: 7
  },
  {
    key: '6',
    region: 'Grand Houston',
    totalRevenue: '$0.00',
    jobs: 0,
    totalClient: 2,
    totalProperties: 2,
    totalCleaners: 11
  },
  {
    key: '7',
    region: 'Austin',
    totalRevenue: '$303.00',
    jobs: 12,
    totalClient: 1,
    totalProperties: 23,
    totalCleaners: 2
  },
  {
    key: '8',
    region: 'New York',
    totalRevenue: '$1,200.00',
    jobs: 150,
    totalClient: 8,
    totalProperties: 20,
    totalCleaners: 100
  },
  {
    key: '9',
    region: 'Chicago',
    totalRevenue: '$900.00',
    jobs: 100,
    totalClient: 5,
    totalProperties: 12,
    totalCleaners: 50
  },
  {
    key: '10',
    region: 'Denver',
    totalRevenue: '$750.00',
    jobs: 90,
    totalClient: 4,
    totalProperties: 10,
    totalCleaners: 40
  },
  {
    key: '11',
    region: 'San Francisco',
    totalRevenue: '$1,000.00',
    jobs: 200,
    totalClient: 10,
    totalProperties: 30,
    totalCleaners: 150
  },
  {
    key: '12',
    region: 'Dallas',
    totalRevenue: '$500.00',
    jobs: 60,
    totalClient: 3,
    totalProperties: 8,
    totalCleaners: 20
  }
]

export const cleanerData = [
  { key: '1', bestCleaner: 'Carla Santos', jobs: 1605, rating: 5 },
  { key: '2', bestCleaner: 'Ernesto De Sous Junior', jobs: 917, rating: 3 },
  { key: '3', bestCleaner: 'Ana Luiza Rondina', jobs: 606, rating: 4 },
  { key: '4', bestCleaner: 'Renata Souza', jobs: 520, rating: 5 },
  { key: '5', bestCleaner: 'Rafael Ramos', jobs: 429, rating: 4 },
  { key: '6', bestCleaner: 'Layene Silva', jobs: 414, rating: 3 },
  { key: '7', bestCleaner: 'Maria Oliveira', jobs: 398, rating: 5 },
  { key: '8', bestCleaner: 'Pedro Costa', jobs: 382, rating: 2 },
  { key: '9', bestCleaner: 'Joao Silva', jobs: 375, rating: 4 },
  { key: '10', bestCleaner: 'Ana Maria Santos', jobs: 368, rating: 3 },
  { key: '11', bestCleaner: 'Paulo Roberto', jobs: 352, rating: 5 },
  { key: '12', bestCleaner: 'Luiz Carlos', jobs: 345, rating: 2 }
]

export const propertyData = [
  { key: '1', bestProperty: '502 San Felipe Ave', cleanings: 297 },
  { key: '2', bestProperty: '520 San Felipe Ave', cleanings: 272 },
  { key: '3', bestProperty: '157 San Diego Ave #1', cleanings: 197 },
  { key: '4', bestProperty: '2308 Palmetto Ave', cleanings: 186 },
  { key: '5', bestProperty: '2310 Palmetto Ave', cleanings: 176 },
  { key: '6', bestProperty: '34 Silva Ave', cleanings: 168 }
]

export const bestClientData = [
  {
    name: 'Carla Santos',
    revenue: 104,
    property: 5,
    jobs: 1605
  },
  {
    name: 'Ernesto De Sous Junior',
    revenue: 28,
    property: 3,
    jobs: 917
  },
  {
    name: 'Ana Luiza Rondina',
    revenue: 9,
    property: 4,
    jobs: 606
  },
  {
    name: 'Renata Souza',
    revenue: 2,
    property: 5,
    jobs: 520
  },
  {
    name: 'Rafael Ramos',
    revenue: 150,
    property: 4,
    jobs: 429
  },
  {
    name: 'Layene Silva',
    revenue: 412,
    property: 3,
    jobs: 414
  },
  {
    name: 'Maria Oliveira',
    revenue: 75,
    property: 5,
    jobs: 398
  },
  {
    name: 'Pedro Costa',
    revenue: 12,
    property: 2,
    jobs: 382
  },
  {
    name: 'Joao Silva',
    revenue: 200,
    property: 4,
    jobs: 375
  },
  {
    name: 'Ana Maria Santos',
    revenue: 60,
    property: 3,
    jobs: 368
  },
  {
    name: 'Paulo Roberto',
    revenue: 45,
    property: 5,
    jobs: 352
  },
  {
    name: 'Luiz Carlos',
    revenue: 18,
    property: 2,
    jobs: 345
  }
]

export const bestPropertyData = [
  {
    bestProperties: '502 San Felipe Ave',
    clients: 'Reinaldo Jose',
    jobs: 52,
    revenue: 52,
    profit: '70%',
    activeSince: '04 Jan, 2022'
  },
  {
    bestProperties: '520 San Felipe Ave',
    clients: 'Smith Jose',
    jobs: 9,
    revenue: 9,
    profit: '70%',
    activeSince: '10 Feb, 2022'
  },
  {
    bestProperties: '157 San Diego Ave #1',
    clients: 'Johan Jose',
    jobs: 4,
    revenue: 4,
    profit: '70%',
    activeSince: '15 March, 2021'
  },
  {
    bestProperties: '2308 Palmetto Ave',
    clients: 'Justin Wilms',
    jobs: 2,
    revenue: 2,
    profit: '70%',
    activeSince: '20 Apr, 2023'
  },
  {
    bestProperties: 'North Carolina',
    clients: 'Kathrin Cooper',
    jobs: 1,
    revenue: 1,
    profit: '70%',
    activeSince: '05 May, 2022'
  },
  {
    bestProperties: '2310 Palmetto Ave',
    clients: 'Emily Cooper',
    jobs: 1,
    revenue: 1,
    profit: '70%',
    activeSince: '28 Jun, 2021'
  },
  {
    bestProperties: '34 Silva Ave',
    clients: 'Laila Penton',
    jobs: 12,
    revenue: 12,
    profit: '70%',
    activeSince: '12 July, 2022'
  },
  {
    bestProperties: '123 Main Street',
    clients: 'John Doe',
    jobs: 30,
    revenue: 100,
    profit: '65%',
    activeSince: '01 Jan, 2023'
  },
  {
    bestProperties: '456 Elm Street',
    clients: 'Jane Smith',
    jobs: 15,
    revenue: 75,
    profit: '75%',
    activeSince: '15 Feb, 2023'
  },
  {
    bestProperties: '789 Oak Street',
    clients: 'Michael Johnson',
    jobs: 25,
    revenue: 120,
    profit: '60%',
    activeSince: '20 Mar, 2023'
  },
  {
    bestProperties: '101 Pine Street',
    clients: 'Emily Davis',
    jobs: 8,
    revenue: 40,
    profit: '80%',
    activeSince: '25 Apr, 2023'
  },
  {
    bestProperties: '202 Cedar Street',
    clients: 'David Wilson',
    jobs: 12,
    revenue: 60,
    profit: '70%',
    activeSince: '30 May, 2023'
  }
]

export const PRICING_TABLE_DATA = [
  {
    key: '1',
    bedrooms: 0,
    bathrooms: 1,
    price: 105,
    exceedPrice: 0,
    avgTime: '1.0h',
    payout: 65
  },
  {
    key: '2',
    bedrooms: 1,
    bathrooms: 1,
    price: 125,
    exceedPrice: 0,
    avgTime: '1.5h',
    payout: 65
  },
  {
    key: '3',
    bedrooms: 1,
    bathrooms: 1.5,
    price: 120,
    exceedPrice: 20,
    avgTime: '1.0h',
    payout: 65
  },
  {
    key: '4',
    bedrooms: 2,
    bathrooms: 1,
    price: 135,
    exceedPrice: 0,
    avgTime: '2.0h',
    payout: 65
  },
  {
    key: '5',
    bedrooms: 2,
    bathrooms: 2,
    price: 150,
    exceedPrice: 0,
    avgTime: '0.0h',
    payout: 65
  },
  {
    key: '6',
    bedrooms: 2,
    bathrooms: 2.5,
    price: 150,
    exceedPrice: 20,
    avgTime: '1.5h',
    payout: 65
  },
  {
    key: '7',
    bedrooms: 3,
    bathrooms: 1,
    price: 155,
    exceedPrice: 20,
    avgTime: '2.5h',
    payout: 65
  },
  {
    key: '8',
    bedrooms: 3,
    bathrooms: 1.5,
    price: 160,
    exceedPrice: 20,
    avgTime: '2.5h',
    payout: 65
  },
  {
    key: '9',
    bedrooms: 3,
    bathrooms: 2,
    price: 170,
    exceedPrice: 20,
    avgTime: '3.0h',
    payout: 65
  }
  // Continue adding more rows as needed
]

export const CLIENT = 'CLIENT'
export const CLEANER = 'CLEANER'

export const IMAGE_MODULE = {
  CLIENT: 'client',
  CLEANER: 'cleaner',
  ADMIN: 'admin',
  PROPERTIES: 'properties',
  CLEANING_COMPLETE: 'cleaning_complete',
  CLEANING_REPORTS: 'cleaning_reports'
}

// Complete list of US timezone options for property timezone selector
export const TIMEZONE_OPTIONS = [
  { value: '', label: 'Select Timezone' },
  // ═══════════════════════════════════════════════════════════════
  // MAIN US TIMEZONES (Most Common)
  // ═══════════════════════════════════════════════════════════════
  { value: 'Pacific/Honolulu', label: 'Hawaii Standard Time (Honolulu)' },
  { value: 'America/Anchorage', label: 'Alaska Standard Time (Anchorage)' },
  { value: 'America/Los_Angeles', label: 'Pacific Standard Time (Los Angeles)' },
  { value: 'America/Denver', label: 'Mountain Standard Time (Denver)' },
  { value: 'America/Phoenix', label: 'Arizona Time (Phoenix - No DST)' },
  { value: 'America/Chicago', label: 'Central Standard Time (Chicago)' },
  { value: 'America/New_York', label: 'Eastern Standard Time (New York)' },
  // ═══════════════════════════════════════════════════════════════
  // OTHER US TIMEZONES
  // ═══════════════════════════════════════════════════════════════
  // US Continental - Eastern
  { value: 'America/Detroit', label: 'Eastern Time - Detroit' },
  { value: 'America/Indiana/Indianapolis', label: 'Eastern Time - Indianapolis' },
  { value: 'America/Indiana/Knox', label: 'Eastern Time - Knox, IN' },
  { value: 'America/Indiana/Marengo', label: 'Eastern Time - Marengo, IN' },
  { value: 'America/Indiana/Petersburg', label: 'Eastern Time - Petersburg, IN' },
  { value: 'America/Indiana/Tell_City', label: 'Eastern Time - Tell City, IN' },
  { value: 'America/Indiana/Vevay', label: 'Eastern Time - Vevay, IN' },
  { value: 'America/Indiana/Vincennes', label: 'Eastern Time - Vincennes, IN' },
  { value: 'America/Indiana/Winamac', label: 'Eastern Time - Winamac, IN' },
  { value: 'America/Kentucky/Louisville', label: 'Eastern Time - Louisville, KY' },
  { value: 'America/Kentucky/Monticello', label: 'Eastern Time - Monticello, KY' },
  // US Continental - Central
  { value: 'America/Menominee', label: 'Central Time - Menominee, MI' },
  { value: 'America/North_Dakota/Beulah', label: 'Central Time - Beulah, ND' },
  { value: 'America/North_Dakota/Center', label: 'Central Time - Center, ND' },
  { value: 'America/North_Dakota/New_Salem', label: 'Central Time - New Salem, ND' },
  // US Continental - Mountain
  { value: 'America/Boise', label: 'Mountain Time - Boise' },
  // Alaska
  { value: 'America/Juneau', label: 'Alaska Time - Juneau' },
  { value: 'America/Sitka', label: 'Alaska Time - Sitka' },
  { value: 'America/Yakutat', label: 'Alaska Time - Yakutat' },
  { value: 'America/Nome', label: 'Alaska Time - Nome' },
  { value: 'America/Metlakatla', label: 'Alaska Time - Metlakatla' },
  { value: 'America/Adak', label: 'Hawaii-Aleutian Time - Adak' },
  // US Territories
  { value: 'America/Puerto_Rico', label: 'Atlantic Time - Puerto Rico' },
  { value: 'Pacific/Guam', label: 'Chamorro Time - Guam' },
  { value: 'Pacific/Pago_Pago', label: 'Samoa Time - American Samoa' },
  { value: 'Pacific/Saipan', label: 'Chamorro Time - Saipan' },
  { value: 'America/St_Thomas', label: 'Atlantic Time - US Virgin Islands' },
  // UTC
  { value: 'UTC', label: 'UTC (Coordinated Universal Time)' }
]
